export const darkTokens = {
  colorPrimary: "#f4b800",
  colorBgBase: "#0d0f14",
  colorTextBase: "#f0eee8",
  borderRadius: 8,
  fontFamily: '"Inter", "Roboto", sans-serif',
  colorLink: "#f4b800",
  colorLinkHover: "#ffd230",
  colorSuccess: "#2eb85c",
  colorError: "#e54d42",
  colorBorder: "#262a35",
  colorBgContainer: "#14171f",
  colorBgElevated: "#1a1d28",
};

export const lightTokens = {
  colorPrimary: "#c49200",
  colorBgBase: "#f5f3ee",
  colorTextBase: "#1c1914",
  borderRadius: 8,
  fontFamily: '"Inter", "Roboto", sans-serif',
  colorLink: "#c49200",
  colorLinkHover: "#a07800",
  colorSuccess: "#279950",
  colorError: "#d43b30",
  colorBorder: "#ddd9cf",
  colorBgContainer: "#ffffff",
  colorBgElevated: "#f5f3ee",
};

export const darkComponentTokens = {
  Card: {
    colorBgContainer: "#14171f",
    headerBg: "#14171f",
    colorBorderSecondary: "#262a35",
  },
  Modal: {
    contentBg: "#14171f",
    headerBg: "#14171f",
    footerBg: "#14171f",
    titleColor: "#f0eee8",
  },
  Input: {
    activeBorderColor: "#f4b800",
    hoverBorderColor: "#f4b800",
    activeShadow: "0 0 0 2px rgba(244, 184, 0, 0.15)",
  },
  InputNumber: {
    activeBorderColor: "#f4b800",
    hoverBorderColor: "#f4b800",
    activeShadow: "0 0 0 2px rgba(244, 184, 0, 0.15)",
  },
  Select: {
    colorBgContainer: "#ffffff",
    colorText: "#1c1914",
    optionSelectedColor: "#1c1914",
  },
  Button: {
    defaultBg: "rgba(244, 184, 0, 0.07)",
    defaultBorderColor: "rgba(244, 184, 0, 0.35)",
    defaultColor: "#f4b800",
    defaultHoverBg: "rgba(244, 184, 0, 0.13)",
    defaultHoverBorderColor: "rgba(244, 184, 0, 0.55)",
    defaultHoverColor: "#f4b800",
    defaultGhostBorderColor: "#262a35",
    defaultGhostColor: "#f0eee8",
  },
};

export const lightComponentTokens = {
  Card: {
    colorBgContainer: "#ffffff",
    headerBg: "#ffffff",
    colorBorderSecondary: "#ddd9cf",
  },
  Modal: {
    contentBg: "#ffffff",
    headerBg: "#ffffff",
    footerBg: "#f5f3ee",
    titleColor: "#1c1914",
  },
  Input: {
    activeBorderColor: "#c49200",
    hoverBorderColor: "#c49200",
    activeShadow: "0 0 0 2px rgba(196, 146, 0, 0.15)",
  },
  InputNumber: {
    activeBorderColor: "#c49200",
    hoverBorderColor: "#c49200",
    activeShadow: "0 0 0 2px rgba(196, 146, 0, 0.15)",
  },
  Select: {
    colorBgContainer: "#ffffff",
    colorText: "#1c1914",
    optionSelectedColor: "#1c1914",
  },
  Button: {
    defaultBg: "rgba(196, 146, 0, 0.07)",
    defaultBorderColor: "rgba(196, 146, 0, 0.35)",
    defaultColor: "#c49200",
    defaultHoverBg: "rgba(196, 146, 0, 0.13)",
    defaultHoverBorderColor: "rgba(196, 146, 0, 0.55)",
    defaultHoverColor: "#c49200",
    defaultGhostBorderColor: "#ddd9cf",
    defaultGhostColor: "#1c1914",
  },
};
